export default __webpack_public_path__ + "static/media/mtt2.25f6302a.jpg";